<template>
  <div>
    <b-form>
      <div class="form-group flex-inline-form-lg">
        <b-input-group class="fill-width">
          <b-input-group-text slot="prepend">
            <i class="fa fa-search"></i>
          </b-input-group-text>
          <b-form-input
            style="height:auto;"
            type="text"
            placeholder="Search vehicle group"
            @input="onChangeSearchQuery($event)"
            v-model="searchQuery"></b-form-input>
        </b-input-group>
        <b-input-group v-if="!hideCompanySelect">
          <company-multi-select
              :multiple="false"
              having="vehicle"
              :init-selection-id="companyIdQuery"
              @on-selected="onCompanySelected"
            />
        </b-input-group>
        <b-input-group style="min-width: 150px;">
          <b-form-select
            style="height:auto;"
            v-model="sortType"
            @change="onChangeSortType($event)"
            :options="sortOptions"></b-form-select>
        </b-input-group>
        <b-input-group>
          <b-button
            @click="createVehicle()"
            variant="success"
            title="Create new vehicle">
            New vehicle group &nbsp;<i class="fa fa-plus"></i>
          </b-button>
        </b-input-group>
      </div>
    </b-form>
    <b-overlay :show="isVehicleListLoading">
      <b-list-group class="no-box" v-if="totalRows">
        <b-list-group-item
          v-for="vehicle in vehicle_groups"
          :key="vehicle.id">
          <div class="pull-left">
            <router-link :to="'vehicle_group/' + vehicle.id">
              <strong>{{vehicle.name}}</strong>
            </router-link>
            <p class="mb-1">{{vehicle.company.name}}</p>
            <small :title="formatDateTime(vehicle.created_at)">Created at: {{formatDateDistance(vehicle.created_at)}}</small>
          </div>
          <div v-if="hasAccessVehicle(vehicle)" class="pull-right">
            <b-button v-if="canIEditVehicle(vehicle)" variant="outline-primary" @click="editVehicle(vehicle.id)">
              <i class="fa fa-pencil-square-o"></i>&nbsp; Edit
            </b-button>
            <b-dropdown v-if="canIDeleteVehicle(vehicle)" variant="outline-primary" class="m-md-2">
              <i class="fa fa-gear" slot="button-content"></i>
              <b-dropdown-item @click="deleteVehicle(vehicle.id)" class="text-danger">Remove</b-dropdown-item>
            </b-dropdown>
          </div>
        </b-list-group-item>
      </b-list-group>
      <div style="height:150px;" v-if="isVehicleListLoading && totalRows === 0"></div>
    </b-overlay>
    <!-- <b-pagination class="mt-3" align="center" size="md" :total-rows="totalRows" v-model="currentPage" :per-page="query_count" v-if="totalRows">
    </b-pagination> -->
    <nav aria-label="Vehicle group pagination" class="pull-right mt-3">
      <ul class="pagination">
        <li class="page-item" :class="{disabled: prevDisabled}">
          <a class="page-link" href="#" @click.prevent="prevPage()"><span aria-hidden="true">&laquo;</span> Previous</a>
        </li>
        <li class="page-item" :class="{disabled: nextDisabled}">
          <a class="page-link" href="#" @click.prevent="nextPage()">Next <span aria-hidden="true">&raquo;</span></a>
        </li>
      </ul>
    </nav>
    <b-alert show v-if="isFetched & totalRows === 0">There's no vehicle group inside this company.</b-alert>
    <div>
      <b-modal
        id="delete_vehicle"
        title="Delete Vehicle"
        header-bg-variant="danger"
        ok-variant="danger"
        @ok="confirmedDeleteVehicle(deleteVehicleGroupId)">
        <p class="my-4">Are you sure want to delete this vehicle group?</p>
      </b-modal>
    </div>
  </div>
</template>
<script>
import dateMixin from '@/mixins/date';
import vehicleMixin from '@/mixins/vehicle';
import routeQuery from '@/mixins/route_query';
import { throttle, isEmpty, uniqBy, last, head } from 'lodash';
// import { log } from 'util';
import CompanyMultiSelect from '@/components/CompanyMultiSelect';

export default {
  name: 'vehicle_group_table',
  mixins: [dateMixin, vehicleMixin, routeQuery],
  components: {
    CompanyMultiSelect,
  },
  props: {
    companyId: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      deleteVehicleGroupId: null,
      loaded: false,
      disableEdit: false,
      disableCreate: false,
      searchQuery: '',
      currentPage: 1,
      sortOptions: [
        { value: null, text: 'Sort By', disabled: true },
        { value: 'ID.DESC', text: 'Newer' },
        { value: 'ID.ASC', text: 'Older' },
      ],
      sortType: null,
      lastData: null,
      lastDataAr: [],
    };
  },
  created() {
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'vehicle_group', name: 'Vehicles Group' },
    ]);
    this.$store.commit('vehicle_group/CLEAR_QUERY');
    this.initFromUrl();
  },
  computed: {
    prevDisabled() {
      return this.lastData === null;
    },
    nextDisabled() {
      return this.vehicle_groups.length < 10;
    },
    hideCompanySelect() {
      return this.companyId !== '';
    },
    companyIdQuery() {
      return this.getRouteQuery('company_id', '');
    },
    vehicle_groups() {
      const vehicle_g = this.$store.getters['vehicle_group/vehicle_groups'];
      return uniqBy(vehicle_g, 'id');
    },
    count_all() {
      return this.$store.getters['vehicle_group/count_all'];
    },
    query_count() {
      return this.$store.getters['vehicle_group/query_count'];
    },
    totalRows() {
      return this.count_all;
    },
    isNotEmpty() {
      return !(this.count_all === 0 && this.searchQuery === '');
    },
    userData() {
      return this.$store.getters.userData.account.access.MAIN.VEHICLE_GROUP;
    },
    is_data_loaded() {
      return this.$store.getters['vehicle_group/dataLoaded'];
    },
    vehicle_groupGetters() {
      return this.$store.getters['vehicle_group/loadVehicle'];
    },
    isVehicleListLoading() {
      return this.vehicle_groupGetters === 'LOADING';
    },
    isFetched() {
      return this.vehicle_groupGetters === 'LOADED';
    },
  },
  watch: {
    currentPage(newValue) {
      if (this.is_data_loaded) {
        this.$store.commit('vehicle_group/SET_QUERY_PAGE', newValue);
        this.loadData();
      }
    },
  },
  methods: {
    resetPagination() {
      this.lastData = null;
      this.lastDataAr = [];
    },
    prevPage() {
      this.lastDataAr.pop();
      if (this.lastDataAr.length) {
        this.lastData = last(this.lastDataAr);
      } else {
        this.lastData = null;
      }
      this.loadData();
    },
    nextPage() {
      const currSort = isEmpty(this.sortType) ? '' : this.sortType;
      const sortBy = head(currSort.split('.'));
      const lastDataKey = isEmpty(sortBy) ? 'id' : sortBy.toLowerCase();
      const skipBy = isEmpty(sortBy) ? 'ID' : sortBy;
      this.$store.commit('vehicle_group/SET_SKIP_BY', skipBy);
      const group = last(this.vehicle_groups);
      this.lastDataAr.push(group[lastDataKey]);
      this.lastData = group[lastDataKey];
      this.loadData();
    },
    initFromUrl() {
      let fCompanyId = this.getRouteQuery('company_id');
      const sort = this.getRouteQuery('sort');
      const search = this.getRouteQuery('q');

      if (this.companyId !== '') {
        fCompanyId = this.companyId;
      }

      if (typeof fCompanyId !== 'undefined') {
        this.setCompanyId({ id: fCompanyId }, true);
      }
      if (sort !== undefined) {
        this.onChangeSortType(sort, true);
      }
      if (search !== undefined) {
        this.onChangeSearchQuery(search, true);
      }

      this.loadInfoAndData();
    },
    updateSearchQuery: throttle((context, searchTerm) => {
      const searchQuery = searchTerm.trim();
      context.$store.commit('vehicle_group/SET_QUERY_SEARCH', searchQuery);
      context.loadInfoAndData();
      context.resetPagination();
    }, 500, {
      leading: false,
    }),
    loadInfoAndData() {
      this.$store.dispatch('vehicle_group/LOAD_INFO');
      this.loadData();
    },
    loadData() {
      this.$store.commit('vehicle_group/SET_QUERY_LAST_DATA', this.lastData);
      return this.$store.dispatch('vehicle_group/LOAD_DATA');
    },
    editVehicle(vehicleGroupId) {
      this.$router.push(`/vehicle_group/${vehicleGroupId}/edit`);
    },
    createVehicle() {
      this.$router.push('/vehicle_group/create');
    },
    deleteVehicle(vehicleGroupId) {
      this.deleteVehicleGroupId = vehicleGroupId;
      this.$bvModal.show('delete_vehicle');
    },
    confirmedDeleteVehicle(vehicleGroupId) {
      this.$store.dispatch('vehicle_group/DELETE_DATA', vehicleGroupId).then((ok) => {
        if (ok) this.loadInfoAndData();
      });
    },
    onCompanySelected(selected) {
      this.setCompanyId(selected);
      this.loadInfoAndData();
    },
    setCompanyId(selected, fromInit = false) {
      if (typeof selected !== 'undefined' && selected !== null) {
        this.$store.commit('vehicle_group/SET_COMPANY_ID', selected.id);
        const currId = this.getRouteQuery('company_id', '');
        if (!fromInit && selected.id !== currId) {
          this.setRouteQuery('company_id', selected.id);
        }
      } else {
        this.$store.commit('vehicle_group/SET_COMPANY_ID', null);
        if (!fromInit) {
          this.removeRouteQuery('company_id');
        }
      }
    },
    onChangeSortType(newValue, fromInit = false) {
      if (!fromInit) {
        this.setRouteQuery('sort', newValue);
      }
      this.$store.commit('vehicle_group/SET_QUERY_SORT', newValue);
      this.sortType = newValue;

      if (!fromInit) {
        this.loadData();
      }
    },
    onChangeSearchQuery(newValue, fromInit = false) {
      this.$store.commit('vehicle_group/SET_QUERY_SEARCH', newValue);
      if (!fromInit) {
        if (!isEmpty(newValue)) {
          this.setRouteQuery('q', newValue);
        } else {
          this.removeRouteQuery('q');
        }
      }
      this.searchQuery = newValue;

      if (!fromInit) {
        this.updateSearchQuery(this, newValue);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/VehicleGroupTable.vue